export const TEMPLATE_MODES = {
  draft: 0,
  published: 1,
};
